module.exports = _IndicoCoreRedux;